import React from 'react';
import { PurchaseRequestForm } from '../components/PurchaseRequestForm';

export const NewServiceRequestPage: React.FC = () => {
  return <PurchaseRequestForm mode="CREATE" defaultProcurementType="Service" />;
};
